/* ============================================================
   FLOAT — theme.js
   Age gate · mobile menu · AJAX cart drawer · quantity controls
   Vanilla JS, no dependencies. Talks to Shopify Ajax Cart API.
============================================================ */
(function () {
  "use strict";

  var cfg = window.FLOAT || {};
  var moneyFormat = cfg.moneyFormat || "{{amount}} zł";
  var freeShip = parseInt(cfg.freeShipThreshold, 10) || 0; // in cents
  var strings = cfg.strings || {};

  /* ---------- Money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || moneyFormat;
    function defaultTo(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split(".");
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (t || ","));
      var dec = parts[1] ? (d || ".") + parts[1] : "";
      return intPart + dec;
    }
    switch ((f.match(placeholderRegex) || [])[1]) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = defaultTo(cents, 0, " "); break;
      default: value = defaultTo(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }
  window.FLOATformatMoney = formatMoney;

  /* ---------- DOM helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ====================================================
     AGE GATE
  ==================================================== */
  function initAgeGate() {
    var root = $("#age-gate");
    if (!root) { document.body.classList.add("age-confirmed"); return; }
    var key = "float_age_confirmed";
    var confirmed = false;
    try { confirmed = localStorage.getItem(key) === "1"; } catch (e) {}
    if (confirmed) { document.body.classList.add("age-confirmed"); return; }

    var card = $(".ag-card", root);
    var btnYes = $("[data-ag-confirm]", root);
    var btnNo = $("[data-ag-decline]", root);
    var btnBack = $("[data-ag-back]", root);

    if (btnYes) btnYes.addEventListener("click", function () {
      try { localStorage.setItem(key, "1"); } catch (e) {}
      document.body.classList.add("age-confirmed");
    });
    if (btnNo) btnNo.addEventListener("click", function () { card.classList.add("ag-decline-shown"); });
    if (btnBack) btnBack.addEventListener("click", function () { card.classList.remove("ag-decline-shown"); });
  }

  /* ====================================================
     MOBILE MENU
  ==================================================== */
  function initMobileMenu() {
    var menu = $("#mobile-menu");
    if (!menu) return;
    function open() { menu.classList.add("open"); document.body.style.overflow = "hidden"; }
    function close() { menu.classList.remove("open"); document.body.style.overflow = ""; }
    $all("[data-menu-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); open(); }); });
    $all("[data-menu-close]", menu).forEach(function (b) { b.addEventListener("click", close); });
    $all("a", menu).forEach(function (a) { a.addEventListener("click", close); });
  }

  /* ====================================================
     CART DRAWER (AJAX)
  ==================================================== */
  var drawer = {
    panel: null, backdrop: null, itemsEl: null, countEls: [], footEl: null, shipEl: null,
  };

  function openDrawer() {
    if (!drawer.panel) return;
    drawer.panel.classList.add("cd-open");
    drawer.backdrop.classList.add("cd-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer.panel) return;
    drawer.panel.classList.remove("cd-open");
    drawer.backdrop.classList.remove("cd-open");
    document.body.style.overflow = "";
  }

  function toast(msg) {
    var t = $("#float-toast");
    if (!t) { t = document.createElement("div"); t.id = "float-toast"; t.className = "float-toast"; document.body.appendChild(t); }
    t.innerHTML = msg;
    t.classList.add("show");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  function getCart() {
    return fetch(cfg.routes && cfg.routes.cart ? cfg.routes.cart + ".js" : "/cart.js", {
      headers: { "Content-Type": "application/json" }
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    // Update count badges everywhere
    drawer.countEls.forEach(function (el) { el.textContent = cart.item_count; });
    $all("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });

    if (!drawer.itemsEl) return;

    // Free-shipping bar
    if (drawer.shipEl && freeShip > 0) {
      var remaining = freeShip - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / freeShip) * 100));
      var label, amount;
      if (remaining <= 0) {
        label = strings.freeShipUnlocked || "Darmowa dostawa odblokowana ✓";
        amount = formatMoney(cart.total_price);
      } else {
        label = (strings.freeShipRemaining || "Do darmowej dostawy brakuje") + " " + formatMoney(remaining);
        amount = formatMoney(cart.total_price) + " / " + formatMoney(freeShip);
      }
      drawer.shipEl.innerHTML =
        '<div class="cd-ship-row"><strong>' + label + '</strong><span>' + amount + '</span></div>' +
        '<div class="cd-bar"><div style="width:' + pct + '%"></div></div>';
    }

    // Items
    if (!cart.items.length) {
      drawer.itemsEl.innerHTML =
        '<div class="cd-empty"><strong>' + (strings.cartEmpty || "Koszyk jest pusty") + '</strong>' +
        '<p>' + (strings.cartEmptyNote || "Czas to zmienić — destylarnia czeka.") + '</p>' +
        '<a class="btn primary" href="' + (cfg.routes ? cfg.routes.all_products || "/collections/all" : "/collections/all") + '" style="margin-top:16px;">' +
        (strings.continueShopping || "Do sklepu →") + '</a></div>';
      if (drawer.footEl) drawer.footEl.style.display = "none";
      return;
    }
    if (drawer.footEl) drawer.footEl.style.display = "";

    var html = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x$1$2") + '" alt="" loading="lazy">'
        : "🥃";
      var variant = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : (it.product_type || "");
      return '<div class="cd-item" data-key="' + it.key + '">' +
        '<div class="cd-thumb">' + img + '</div>' +
        '<div><a class="cd-name" href="' + it.url + '">' + it.product_title + '</a>' +
        (variant ? '<div class="cd-variant">' + variant + '</div>' : "") +
        '<div class="cd-qty">' +
        '<button data-qty-down aria-label="Mniej">−</button><span>' + it.quantity + '</span><button data-qty-up aria-label="Więcej">+</button>' +
        '</div></div>' +
        '<div><div class="cd-price">' + formatMoney(it.final_line_price) + '</div>' +
        '<button class="cd-remove" data-remove>' + (strings.remove || "Usuń") + '</button></div>' +
        '</div>';
    }).join("");
    drawer.itemsEl.innerHTML = html;

    // Footer totals
    if (drawer.footEl) {
      var totalEl = $("[data-cart-total]", drawer.footEl);
      var subEl = $("[data-cart-subtotal]", drawer.footEl);
      if (subEl) subEl.textContent = formatMoney(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }

    // Wire item controls
    $all(".cd-item", drawer.itemsEl).forEach(function (row) {
      var key = row.getAttribute("data-key");
      var span = $(".cd-qty span", row);
      var qty = parseInt(span.textContent, 10);
      var up = $("[data-qty-up]", row), down = $("[data-qty-down]", row), rm = $("[data-remove]", row);
      if (up) up.addEventListener("click", function () { changeQty(key, qty + 1); });
      if (down) down.addEventListener("click", function () { changeQty(key, qty - 1); });
      if (rm) rm.addEventListener("click", function () { changeQty(key, 0); });
    });
  }

  function changeQty(key, quantity) {
    fetch((cfg.routes && cfg.routes.cart_change ? cfg.routes.cart_change : "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart)
      .then(refreshCartPage);
  }

  function addToCart(id, quantity, btn) {
    if (btn) { btn.setAttribute("disabled", "disabled"); }
    fetch((cfg.routes && cfg.routes.cart_add ? cfg.routes.cart_add : "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast((res.data && res.data.description) || "Nie udało się dodać"); return; }
        var title = res.data.items ? res.data.items[0].product_title : (res.data.product_title || "Produkt");
        toast("✓ " + (strings.added || "Dodano") + ": <strong>" + title + "</strong>");
        return getCart().then(function (cart) {
          renderCart(cart);
          var item = (res.data.items && res.data.items[0]) || res.data;
          var prodId = item ? (item.product_id || item.id) : null;
          var ev = new CustomEvent("cart:added", { detail: { productId: prodId }, cancelable: true });
          document.dispatchEvent(ev);
          if (!ev.defaultPrevented) openDrawer();
        });
      })
      .catch(function () { toast("Błąd połączenia"); })
      .finally(function () { if (btn) btn.removeAttribute("disabled"); });
  }

  // Re-render the full cart page if present (so qty changes reflect there too)
  function refreshCartPage() {
    if ($("[data-cart-page]")) { window.location.reload(); }
  }

  function initCartDrawer() {
    drawer.panel = $("#cart-drawer");
    drawer.backdrop = $("#cart-drawer-backdrop");
    drawer.itemsEl = $("[data-drawer-items]");
    drawer.footEl = $("[data-drawer-foot]");
    drawer.shipEl = $("[data-drawer-ship]");
    drawer.countEls = $all(".cd-count");

    $all("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    });
    if (drawer.backdrop) drawer.backdrop.addEventListener("click", closeDrawer);
    $all("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

    // Add-to-cart buttons (product cards + PDP forms)
    document.addEventListener("submit", function (e) {
      var form = e.target.closest && e.target.closest("form[data-add-to-cart]");
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector("[name='id']");
      var qtyEl = form.querySelector("[name='quantity']");
      if (!id || !id.value) return;
      addToCart(id.value, qtyEl ? parseInt(qtyEl.value, 10) : 1, form.querySelector("[type='submit']"));
    });

    // Initial load
    if (drawer.itemsEl) getCart().then(renderCart);
    else getCart().then(function (cart) {
      $all("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      $all(".cd-count").forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* ====================================================
     QUANTITY STEPPERS (PDP, cart line items with name=quantity)
  ==================================================== */
  function initQtySteppers() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-qty-stepper] button");
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest("[data-qty-stepper]");
      var input = wrap.querySelector("input");
      var val = parseInt(input.value, 10) || 1;
      if (btn.hasAttribute("data-plus")) val++;
      else if (val > (parseInt(input.min, 10) || 1)) val--;
      input.value = val;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  /* ====================================================
     PDP VARIANT PICKER
  ==================================================== */
  function initVariantPicker() {
    var root = $("[data-product-form]");
    if (!root) return;
    var variantsScript = $("[data-variants-json]");
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    var idInput = root.querySelector("[name='id']");
    var priceEl = $("[data-product-price]");
    var atcLabel = $("[data-atc-label]");
    var submit = root.querySelector("[type='submit']");

    function selectVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (atcLabel) atcLabel.textContent = (strings.addToCart || "Do koszyka") + " · " + formatMoney(v.price);
      if (submit) {
        if (v.available) { submit.removeAttribute("disabled"); }
        else { submit.setAttribute("disabled", "disabled"); if (atcLabel) atcLabel.textContent = strings.soldOut || "Wyprzedane"; }
      }
    }

    $all("[data-variant-option]").forEach(function (el) {
      el.addEventListener("click", function () {
        var vid = el.getAttribute("data-variant-id");
        $all("[data-variant-option]").forEach(function (o) { o.classList.remove("active"); });
        el.classList.add("active");
        var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
        selectVariant(v);
      });
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    initAgeGate();
    initMobileMenu();
    initCartDrawer();
    initQtySteppers();
    initVariantPicker();
  });
})();
